import { useInfiniteQuery, keepPreviousData } from '@tanstack/react-query';
import type { SearchResponse } from '@pms/shared';
import { searchStays, type SearchParams } from '../services/api/search.api';

/**
 * Paginated search via useInfiniteQuery (drives the "Load more" UX). The query key
 * excludes `page`, so changing any filter/sort starts a fresh result set; refetches
 * keep prior data (no skeleton flash). Facets come from the first page.
 */
export function useSearch(params: Omit<SearchParams, 'page'>) {
  return useInfiniteQuery<SearchResponse>({
    queryKey: ['search', params],
    queryFn: ({ pageParam }) => searchStays({ ...params, page: pageParam as number }),
    initialPageParam: 1,
    getNextPageParam: (last) =>
      last.meta.page < last.meta.totalPages ? last.meta.page + 1 : undefined,
    placeholderData: keepPreviousData,
  });
}
